var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellRinging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M11.38303,3.24472L8.45128,.30297C3.37878,4.14495,.28101,10.04655,0,16.4036H4.10965c.29532-5.26468,2.97251-10.10821,7.27338-13.15888Zm25.41383,13.16888h4.10965c-.29767-6.35671-3.39425-12.2555-8.45728-16.11063l-2.91375,2.94175c4.28708,3.06502,6.95663,7.90565,7.26138,13.16688v.002Zm-4.04166,1.02591c0-6.29746-3.36371-11.56901-9.22921-12.9629v-1.39988c0-1.69924-1.3775-3.07674-3.07674-3.07674s-3.07674,1.3775-3.07674,3.07674v1.39988c-5.8875,1.39988-9.22921,6.64543-9.22921,12.9629v10.26113l-4.10165,4.09365v2.05183H36.85886v-2.05183l-4.10365-4.09365v-10.26113Zm-12.30495,22.56008c.27555,.00414,.55066-.02337,.81993-.08199,1.31835-.28067,2.41913-1.18245,2.95375-2.41979,.20819-.50745,.3129-1.05139,.30797-1.59986h-8.1993c.01643,2.26467,1.85293,4.09403,4.11765,4.10165Z",
    fill: "#ee7c2f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRinging);
export default __webpack_public_path__ + "static/media/bell-ringing.2c5008d0991827e8ae0ec66af5e854ff.svg";
export { ForwardRef as ReactComponent };